module.exports = __webpack_public_path__ + "static/images/task-yellow-bg.fe1013213.png";